<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.2071 17.5C5.57527 17.5 4.90835 17.2143 4.45203 16.75C3.99571 16.2857 3.75 15.6429 3.75 15C3.75 14.3571 4.03081 13.7143 4.45203 13.2143C4.90835 12.75 5.54017 12.5 6.2071 12.5C6.83892 12.5 7.47076 12.7857 7.92708 13.2143C8.38339 13.6786 8.6642 14.3214 8.6642 15C8.6642 15.6429 8.38339 16.2857 7.92708 16.75C7.50586 17.25 6.83892 17.5 6.2071 17.5ZM16.7375 16.75C17.1938 16.2857 17.4746 15.6429 17.4746 15C17.4746 14.3571 17.1938 13.7143 16.7375 13.2143C16.2812 12.75 15.6494 12.5 15.0175 12.5C14.3857 12.5 13.7188 12.7857 13.2625 13.2143C12.8062 13.6786 12.5604 14.3214 12.5604 15C12.5604 15.6429 12.8413 16.2857 13.2625 16.75C13.7188 17.2143 14.3506 17.5 15.0175 17.5C15.6143 17.5 16.2812 17.25 16.7375 16.75ZM25.5129 16.75C25.9692 16.2857 26.25 15.6429 26.25 15C26.25 14.3571 25.9692 13.7143 25.5129 13.2143C25.0566 12.75 24.4247 12.5 23.7929 12.5C23.1611 12.5 22.4941 12.7857 22.0378 13.2143C21.5815 13.6786 21.3358 14.3214 21.3358 15C21.3358 15.6429 21.6166 16.2857 22.0378 16.75C22.4941 17.2143 23.126 17.5 23.7929 17.5C24.3896 17.5 25.0566 17.25 25.5129 16.75Z" :fill="fill"/>
  </svg>
</template>

<script>
  export default {
    name: 'dotsIcon',
    props: {
      fill: {
        type: String,
        default: '#109CF1'
      }
    }
  }
</script>
